import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { inject, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedAnalyticsService } from '@luggagehero/shared/services/analytics';
import { Angulartics2Facebook, Angulartics2GoogleTagManager, Angulartics2Module } from 'angulartics2';

/**
 * Do not specify providers for modules that might be imported by a lazy loaded module.
 */

@NgModule({
  imports: [CommonModule, RouterModule, Angulartics2Module.forRoot()],
  providers: [provideHttpClient(withInterceptorsFromDi())],
})
export class AnalyticsModule {
  constructor() {
    const angulartics2GoogleTagManager = inject(Angulartics2GoogleTagManager);
    const angulartics2Facebook = inject(Angulartics2Facebook);

    inject(SharedAnalyticsService);

    // start tracking!
    angulartics2GoogleTagManager.startTracking();
    angulartics2Facebook.startTracking();
  }
}
